if (!customElements.get("purchase-confirmation")) {
  class ComponentPurchaseConfirmation extends HTMLElement {
    constructor() {
      super();

      this.elAtcForm = document.querySelector("add-to-cart-form");
      this.elAtcButton = document.querySelector("product-buttons .add");
      this.preventPurchase = this.dataset.prevent === "true";
      this.cartProps = this.dataset.cartProps ? this.dataset.cartProps : 'Final Sale'

      if (this.preventPurchase) {
        this.elCheckboxAccept = this.querySelector('[name="enable-purchase"]');
        this.elCheckboxAccept.addEventListener("change", (event) => {
          this.renderComponent();
        });

        this.renderComponent();
      }
    }

    renderComponent() {
      if (this.elCheckboxAccept.checked) {
        this.enableCart(true);
      } else {
        this.enableCart(false);
      }
    }

    enableCart(status) {
      this.elAtcButton.disabled = !status;
      if (status) {

        let cartProps = this.cartProps.indexOf(',') > -1 ? this.cartProps.split(',') : [this.cartProps];
        let cartPropsValues = {
          "Final Sale": `this item cannot be returned.`,
          "Single Earring": `This is a single earring, not a pair`
        }

        cartProps.forEach(cartProp => {
          let elBundleMainInputHidden = document.createElement("input");
          elBundleMainInputHidden.type = "hidden";
          elBundleMainInputHidden.name = `properties[${cartProp}]`;

          if (cartProp.trim() === "Exchange only") {
            elBundleMainInputHidden.value = "true";
          } else {
            elBundleMainInputHidden.value = `${cartPropsValues[cartProp]}`;
          }

          elBundleMainInputHidden.classList.add("bundle-additional-item-purchase");
          this.elAtcForm.appendChild(elBundleMainInputHidden);
        })
      } else {
        let elBundleMainInputHidden = this.elAtcForm.querySelector(
          ".bundle-additional-item-purchase"
        );
        if (elBundleMainInputHidden) elBundleMainInputHidden.remove();
      }
    }
  }
  customElements.define("purchase-confirmation", ComponentPurchaseConfirmation);
}